var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "add_company_dialog",
      attrs: {
        modal: true,
        "modal-append-to-body": true,
        title: _vm.title,
        visible: _vm.show,
        "close-on-click-modal": false,
        "show-close": true,
        "close-on-press-escape": true,
        "before-close": _vm.clickCancel,
        width: "600px"
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "newCompanyForm",
          staticClass: "newCompanyForm",
          attrs: { model: _vm.newCompanyForm, rules: _vm.rules }
        },
        [
          _c(
            "div",
            { staticClass: "dialog_head" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "companyName", label: "公司名称" } },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "请输入公司名称",
                      maxlength: "20"
                    },
                    model: {
                      value: _vm.newCompanyForm.companyName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.newCompanyForm,
                          "companyName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "newCompanyForm.companyName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "companyCode", label: "公司编码" } },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "请输入公司编码",
                      maxlength: "20"
                    },
                    model: {
                      value: _vm.newCompanyForm.companyCode,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.newCompanyForm,
                          "companyCode",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "newCompanyForm.companyCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "useScope", label: "使用范围" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择使用范围", multiple: "" },
                      model: {
                        value: _vm.newCompanyForm.useScope,
                        callback: function($$v) {
                          _vm.$set(_vm.newCompanyForm, "useScope", $$v)
                        },
                        expression: "newCompanyForm.useScope"
                      }
                    },
                    _vm._l(_vm.useScopeOptions, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.labelName, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.clickCancel } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitForm("newCompanyForm")
                }
              }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a0b999e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a0b999e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/educationalAdmin/educationalAdminMenu/subjectDialog/addCompanyDialog.vue
// module id = null
// module chunks = 